import React from "react";
import MenuItem from "@material-ui/core/MenuItem";

// import TextField from "./TextField";
import AccTextField from "./accessabilityTextField.js";

// FIXME: If a menu item with a value of 0 is selected the item doesn't appear to be selected
// https://github.com/mui-org/material-ui/issues/10531
// https://github.com/mui-org/material-ui/issues/8990


const AccessabilitySelect = ({ options = [], native, id, label, ...rest }) => {
    const labelText =
        rest["aria-label"] ||
        (typeof label === "string" ? label : null) ||
        rest.identification ||
        rest.name ||
        id ||
        "Select";

    const selectProps = {
        ...(rest.SelectProps || {}),
        ...(native ? { native: true } : {}),
        ...(native
            ? {
                inputProps: {
                    ...(rest.SelectProps?.inputProps || {}),
                    "aria-label": labelText,
                },
            }
            : {}),
    };

    return (
        <AccTextField
            id={id}
            select
            label={label}
            SelectProps={selectProps}
            {...rest}
        >
            {native
                ? options.map(({ label: optLabel, value, optgroup, items }, idx) =>
                    optgroup ? (
                        <optgroup key={`optgroup-${idx}-${optLabel}`} label={optLabel}>
                            {(items || []).map(({ iLabel, iValue }, jdx) => (
                                <option key={`opt-${idx}-${jdx}-${iValue}`} value={iValue}>
                                    {iLabel}
                                </option>
                            ))}
                        </optgroup>
                    ) : (
                        <option key={`opt-${idx}-${value}`} value={value}>
                            {optLabel}
                        </option>
                    )
                )
                : options.map(({ label: optLabel, value }) => (
                    <MenuItem key={value} disabled={rest.disabled} value={value}>
                        {optLabel}
                    </MenuItem>
                ))}
        </AccTextField>
    );
};

export default AccessabilitySelect;
